// initial state
// shape: [{ id, quantity }]
import Vue from "vue";

const state = {
    driverModel: [1.4886, 4.6496, 0.6968, 1, 0.2641, 0],
    vehicle: [-70, 50 / 3.6],
    bicycle: [30, -20 / 3.6],
    simulation: [10, 0.01, 10],
}

// getters
const getters = {
    getDT(state) {
        return state.simulation[1];
    }
}

// actions
const actions = {
    setSetting(store, payload) {
        const data = store.state[payload.type];
        data[payload.ind] = payload.newVal;
        Vue.set(store.state, payload.type, data);
    }
}

// mutations
const mutations = {

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}